:host {
  line-height: 0;

  svg {
    display: inline-block;
    width: auto;
    height: 1em;
  }
}

.icon {
  display: inline-block;

  /* ------------------------------------ *\
    # Size modifiers
  \* ------------------------------------ */

  &--micro {
    font-size: 12px;
  }

  &--tiny {
    font-size: 16px;
  }

  &--small {
    font-size: 20px;
  }

  &--medium {
    font-size: 24px;
  }

  &--large {
    font-size: 32px;
  }

  &--huge {
    font-size: 40px;
  }

  &--giant {
    font-size: 48px;
  }
}
